"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIPopoverBody;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _classnames = _interopRequireDefault(require("classnames"));

var _sizes = require("HubStyleTokens/sizes");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _PopoverContext = require("../context/PopoverContext");

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n        border-radius: inherit;\n        line-height: 1.5;\n      "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n        border-bottom-left-radius: inherit;\n        border-bottom-right-radius: inherit;\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  background: inherit;\n  padding: ", ";\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Body = _styledComponents.default.div.withConfig({
  displayName: "UIPopoverBody__Body",
  componentId: "r35hcz-0"
})(_templateObject(), function (_ref) {
  var flush = _ref.flush,
      popoverUse = _ref.popoverUse;
  if (flush) return '0';
  if (popoverUse === 'longform') return "0 " + _sizes.TOOLTIP_LONGFORM_PADDING + " 1px";
  if (popoverUse === 'shepherd') return _sizes.SHEPHERD_PADDING_Y + " " + _sizes.POPOVER_PADDING_X;
  if (popoverUse.includes('tooltip')) return _sizes.TOOLTIP_PADDING_Y + " " + _sizes.TOOLTIP_PADDING_X;
  return _sizes.POPOVER_PADDING_Y + " " + _sizes.POPOVER_PADDING_X + " 0";
}, function (_ref2) {
  var popoverUse = _ref2.popoverUse;
  if (popoverUse === 'shepherd') return (0, _styledComponents.css)(_templateObject2());
  if (popoverUse.includes('tooltip')) return (0, _styledComponents.css)(_templateObject3());
  return null;
});

function UIPopoverBody(_ref3) {
  var className = _ref3.className,
      rest = (0, _objectWithoutProperties2.default)(_ref3, ["className"]);
  return _react.default.createElement(Body, (0, _extends2.default)({}, rest, {
    className: (0, _classnames.default)('uiPopoverBody private-popover__body', className),
    popoverUse: (0, _react.useContext)(_PopoverContext.PopoverContext).use
  }));
}

UIPopoverBody.propTypes = {
  children: _propTypes.default.node,
  flush: _propTypes.default.bool
};
UIPopoverBody.displayName = 'UIPopoverBody';
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/tooltip/UIPopoverBody.js
// module id = 390
// module chunks = 5 6 7